import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {ContactPO, CustomerPO} from "@/model/customer";
import {useMutation, useQuery} from "@tanstack/react-query";
import {SearchBO} from "@/service/common.s";
import {WriteCustomerForm} from "@/pages/Customer/WriteCustomer";

export enum CustomerEnum {
    GetCustomerPage = "/customer/getCustomerPage",
    GetCustomer = "/customer/getCustomer",
    CreateCustomer = "/customer/createCustomer",
    UpdateCustomer = "/customer/updateCustomer",
    SearchCustomer = "/customer/searchCustomer",
    FreedCustomers = "/customer/freedCustomers",
    TransferCustomers = "/customer/transferCustomers",
}

export interface CustomerPageBO {
    status: number;
    params: { industryId: number; };
}

export interface CustomerVO extends CustomerPO {
    contacts: ContactPO[]
    paybackMoney: number
    projectAmount: number
    trademarkAmount: number
    unPaybackMoney: number
    copyrightAmount: number
    chanceMoney: number
    expenseMoney: number
}

export interface CustomerPageVO extends CustomerPO {
}

export interface FreedCustomersBO {
    customerIds: number[];
}

export interface TransferCustomersBO {
    customerIds: number[];
    flag: number;
    userId?: number;
    username?: string
}

export const useQueryCustomerPage = () => useMutation({
    mutationFn: ({
                     params,
                 }: CustomerPageBO) => http.post<BaseVO<PaginationVO<CustomerPageVO>>>({
        url: `${CustomerEnum.GetCustomerPage}`,
        data: params,
    }),
})

export const useCreateCustomer = () => useMutation({
    mutationFn: (data: WriteCustomerForm) => http.put<BaseVO<null>>({url: CustomerEnum.CreateCustomer, data}),
})

export const useUpdateCustomer = () => useMutation({
    mutationFn: (data: WriteCustomerForm) => http.post<BaseVO<null>>({url: CustomerEnum.UpdateCustomer, data}),
})

export const useFreedCustomers = () => useMutation({
    mutationFn: (data: FreedCustomersBO) => http.post<BaseVO<null>>({url: CustomerEnum.FreedCustomers, data}),
})

export const useTransferCustomers = () => useMutation({
    mutationFn: (data: TransferCustomersBO) => http.post<BaseVO<null>>({url: CustomerEnum.TransferCustomers, data}),
})

export const useSearchCustomer = () => useMutation({mutationFn: (data: SearchBO) => http.post<BaseVO<CustomerPO[]>>({url: CustomerEnum.SearchCustomer, data})})


export const useQueryCustomer = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<CustomerVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<CustomerVO>>({
        url: CustomerEnum.GetCustomer,
        params: params
    }),
    enabled
})

